import { CloseButton, SaveOverlay } from "@itk/mui-components";
import { hasValue } from "@itk/typescript-utils";
import { Stack } from "@mui/material";
import { useEffect } from "react";
import { DocumentViewer } from "./document-viewer";
import { FileModelState } from "../application-types";
import { GenericDialog } from "src/components/generic-dialog";

export const DocumentViewerDialog = (props: { fileInfo: FileModelState; resetFile: () => void }) => {
  const { fileInfo, resetFile } = props;
  useEffect(() => {
    if (hasValue(fileInfo.fileId) && !fileInfo.previewAvailable) {
      resetFile();
    }
  }, [fileInfo.fileId, fileInfo.previewAvailable]);

  if (!hasValue(fileInfo.fileId) || !fileInfo.previewAvailable) return null;

  return (
    <>
      <GenericDialog
        onClose={resetFile}
        dialogProps={{ maxWidth: "lg" }}
        dialogContentProps={{ sx: { height: "95vh" } }}
        renderDialogActions={<CloseButton onClose={resetFile} variant="outlined" />}
      >
        <Stack display="flex" flexDirection="column" height="100%">
          <DocumentViewer fileId={fileInfo.fileId} />
        </Stack>
      </GenericDialog>
      <SaveOverlay />
    </>
  );
};
